import React, { useState, useRef } from 'react'
import { useEffect } from 'react'
import TicketView from '../../pages/TicketView'

function CreateTickets() {
  
  const [loadCustomfrom, setloadCustomfrom] = useState(false)

  useEffect(() => {
    
      setloadCustomfrom(true)
   
  }, [])

  return (
    <>
      {loadCustomfrom && (
       <>
          <TicketView ticketmodule={true} />
        </>
      )}
    </>
  )
}

export default CreateTickets
